/**
 * OSMARIS CART UPSELL
 *
 * Zwei kleine Aufgaben:
 *
 * 1. Mengenwahl in einer Upsell-Zeile: Preis, Streichpreis und Rabatt-Hinweis aktualisieren
 *    und die versteckte quantity des Formulars mitziehen. Die Staffelpreise sind in Liquid
 *    vorgerendert und haengen als data-Attribute an den Radios — hier wird nichts gerechnet,
 *    damit Theme und Checkout garantiert dieselbe Zahl zeigen.
 *
 * 2. Der Drawer ist beim Klick auf "Hinzufuegen" bereits offen. Ohne den Listener unten wuerde
 *    CartDrawer auf 'variant:add' hin show() aufrufen und die Oeffnungs-Animation erneut
 *    abspielen. Capture-Phase auf document laeuft vor dessen Bubble-Listener.
 */
(() => {
  // Die Section wird bei jeder Warenkorbaenderung neu gerendert; ohne Wachposten haengen
  // danach mehrere identische Listener am Dokument.
  if (window.__osmarisCartUpsellReady) return;
  window.__osmarisCartUpsellReady = true;

  const applyQuantity = (input) => {
    const row = input.closest('.osmaris-upsell-item');
    if (!row) return;

    row.querySelectorAll('.osmaris-upsell-qty').forEach((label) => {
      label.classList.toggle('is-selected', label.contains(input));
    });

    const totalEl = row.querySelector('[data-osmaris-upsell-total]');
    const compareEl = row.querySelector('[data-osmaris-upsell-compare]');
    const pctEl = row.querySelector('[data-osmaris-upsell-pct]');
    const quantityInput = row.querySelector('[data-osmaris-upsell-quantity]');

    if (totalEl) totalEl.textContent = input.dataset.total || totalEl.textContent;

    if (compareEl) {
      const show = input.dataset.hasCompare === '1';
      compareEl.textContent = show ? input.dataset.compare || '' : '';
      compareEl.hidden = !show;
    }

    if (pctEl) {
      const pct = Number(input.dataset.pct) || 0;
      // data-pct ist der EFFEKTIVE Nachlass nach der Aufrundung, nicht der nominelle
      // Staffelsatz — bei 2 Flaschen also 14 %, nicht 15 %. Nur der ist belegbar.
      pctEl.textContent = pct > 0 ? `−${pct} %` : '';
      pctEl.hidden = pct <= 0;
    }

    if (quantityInput) quantityInput.value = input.value;
  };

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (input && input.matches && input.matches('[data-osmaris-upsell-qty]')) {
      applyQuantity(input);
    }
  });

  document.addEventListener(
    'variant:add',
    (event) => {
      const form = event.target;

      if (form && typeof form.closest === 'function' && form.closest('.osmaris-cart-upsell')) {
        if (event.detail) {
          event.detail.blockCartDrawerOpening = true;
        }
      }
    },
    true
  );
})();
